"use client";

import React, { useEffect, useRef, useState } from "react";
import { m, motion } from "framer-motion";
import { globalTransition } from "../../assets/animate/globalAnimation";

function VisionSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div
      ref={sectionRef}
      className="bg-[#2D3A45] lg:py-5 lg:pb-28 relative lg:overflow-visible"
    >
      <div className="absolute left-0 right-0 bg-gradient-to-t -top-28 w-full min-h-28 z-20 from-[#2D3A45] to-transparent"></div>
      <h4 className="text-white hidden lg:block text-2xl font-normal pl-28 pt-10">
        Our Vision
      </h4>
      <div className="border-b hidden lg:block border-b-gray-700 mx-28 my-5"></div>

      <div className="grid grid-cols-6 overflow-hidden">
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={inView ? { x: 0, opacity: 1 } : {}}
          transition={{ ...globalTransition, ease: "easeOut", duration: 1.2 }}
          className="lg:col-span-3  flex justify-center col-span-6 lg:py-10 lg:px-5"
        >
          <div className=" relative w-[70vh] h-[80vh]">
            <div className="absolute top-3 left-2 right-2 lg:hidden">
              <h4 className="text-white text-xl px-2 font-semibold shadow-sm">
                Our Vision
              </h4>
              <div className="border-white border-b mx-2 pt-2"></div>
            </div>

            <img
              src="/assets/image/vision.png"
              alt="Hydraulic excavator arm"
              className="w-full h-full rounded-md object-cover"
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={inView ? { x: 0, opacity: 1 } : {}}
          transition={{ ...globalTransition, ease: "easeOut", duration: 1.2 }}
          className="lg:col-span-3 font-normal text-sm lg:text-xl col-span-6 lg:pr-40 leading-loose lg:leading-[2rem] p-6 flex justify-start items-center text-white"
        >
          To be the premier Hydraulic Systems integrator and service provider,
          driving industrial evolution through innovative solutions, precision
          engineering, and a commitment to providing unparalleled services
          worldwide.
        </motion.div>
      </div>
    </div>
  );
}

export default VisionSection;

// "use client";

// import { useState, useEffect, useRef } from "react";
// import { Box, Typography, Container, Grid, useMediaQuery } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { useTheme } from "@mui/material/styles";
// import { motion } from "framer-motion";

// // Create styled components
// const VisionContainer = styled(Box)(({ theme }) => ({
//   backgroundColor: "#2D3A45", // Dark slate blue background
//   position: "absolute",
//   height: "1200px",
//   padding: theme.spacing(8, 2),
//   [theme.breakpoints.up("md")]: {
//     padding: theme.spacing(10, 4),
//   },
// }));

// const VisionTitle = styled(Typography)(({ theme }) => ({
//   color: "#FFFFFF",
//   fontWeight: 500,
//   marginBottom: theme.spacing(4),
//   position: "relative",
//   "&:after": {
//     content: '""',
//     position: "absolute",
//     bottom: -10,
//     left: 0,
//     width: 60,
//     height: 2,
//     backgroundColor: theme.palette.primary.main,
//   },
// }));

// const VisionText = styled(Typography)(({ theme }) => ({
//   color: "#FFFFFF",
//   lineHeight: 1.6,
// }));

// const ImageContainer = styled(Box)(({ theme }) => ({
//   width: "100%",
//   height: "100%",
//   position: "relative",
//   overflow: "hidden",
//   borderRadius: 4,
// }));

// export default function VisionSection() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
//   const [isVisible, setIsVisible] = useState(false);
//   const sectionRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setIsVisible(true);
//             observer.disconnect();
//           }
//         });
//       },
//       { threshold: 0.1 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => {
//       if (sectionRef.current) {
//         observer.unobserve(sectionRef.current);
//       }
//     };
//   }, []);

//   // Animation variants
//   const leftVariants = {
//     hidden: { opacity: 0, x: -200 },
//     visible: {
//       opacity: 1,
//       x: 0,
//       transition: {
//         duration: 1,
//         ease: "easeOut",
//       },
//     },
//   };

//   const rightVariants = {
//     hidden: { opacity: 0, x: 200 },
//     visible: {
//       opacity: 1,
//       x: 0,
//       transition: {
//         duration: 1,
//         ease: "easeOut",
//       },
//     },
//   };

//   const titleVariants = {
//     hidden: { opacity: 0, y: -50 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         duration: 0.8,
//         ease: "easeOut",
//       },
//     },
//   };

//   return (
//     <VisionContainer ref={sectionRef}>
//       <Container maxWidth="lg">
//         <motion.div
//           initial="hidden"
//           animate={isVisible ? "visible" : "hidden"}
//           variants={titleVariants}
//         >
//           <Typography
//             variant="h3"
//             component="h2"
//             sx={{
//               color: "#FFFFFF",
//               fontWeight: 500,
//               marginBottom: theme.spacing(4),
//               position: "relative",
//               "&:after": {
//                 content: '""',
//                 position: "absolute",
//                 bottom: -10,
//                 left: 0,
//                 width: 60,
//                 height: 2,
//                 backgroundColor: theme.palette.primary.main,
//               },
//             }}
//           >
//             Our Vision
//           </Typography>
//         </motion.div>

//         <Grid container spacing={4} alignItems="center">
//           <Grid item xs={12} md={6}>
//             <motion.div
//               initial="hidden"
//               animate={isVisible ? "visible" : "hidden"}
//               variants={leftVariants}
//             >
//               <ImageContainer>
//                 <img
//                   src="/assets/image/vision.png"
//                   alt="Hydraulic excavator arm against blue sky"
//                   style={{
//                     width: "100%",
//                     height: "auto",
//                     objectFit: "cover",
//                     display: "block",
//                   }}
//                 />
//               </ImageContainer>
//             </motion.div>
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <motion.div
//               initial="hidden"
//               animate={isVisible ? "visible" : "hidden"}
//               variants={rightVariants}
//             >
//               <VisionText variant={isMobile ? "body1" : "h6"}>
//                 To be the premier Hydraulic Systems integrator and service
//                 provider, driving industrial evolution through innovative
//                 solutions, precision engineering, and a commitment to providing
//                 unparalleled services worldwide.
//               </VisionText>
//             </motion.div>
//           </Grid>
//         </Grid>
//       </Container>
//     </VisionContainer>
//   );
// }
